import { render, staticRenderFns } from "./coding.vue?vue&type=template&id=0553295c&"
import script from "./coding.vue?vue&type=script&lang=js&"
export * from "./coding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports